<template>
	<v-layout column>
		<v-list subheader style = 'width: 100%;'>
			<v-list-item  
			  v-if='canCreate' 
			  @click.stop.prevent = 'visibility = true; getAvailableFields();' 
			  style = 'width: 100%;'
			>
				<v-list-item-content>
	                <v-list-item-title>Добавить оповещение</v-list-item-title>
	            </v-list-item-content>
	            <v-list-item-action>
	                <span>
	                	<v-icon class='mx-auto'>add</v-icon>
	                </span>
	            </v-list-item-action>
	        </v-list-item>
	        <v-divider v-if = 'canCreate && !indicator'></v-divider>
	        <v-progress-linear class='ma-0' :color='$store.getters.uiAccent' height='1' :active='indicator' :indeterminate='true'></v-progress-linear>
	        <v-list-item dense v-if = '!notifications.length' list style = 'width: 100%;'>
				<v-list-item-content>
	                <v-list-item-title class="align-center">Оповещений не добавлено</v-list-item-title>
	            </v-list-item-content>
	        </v-list-item>
	        <v-list-group no-action v-for = 's in notifications' :key='s.pp_id'>
	            <v-list-item slot="activator" class = 'mx-0 px-0'>
	            	<v-list-item-action class = 'mr-4'>
	            		<span class = 'caption text-uppercase'>{{s.period}}</span>
	            	</v-list-item-action>
	            	<v-list-item-content class style = 'user-select: none;'>
	            		<v-list-item-title><span v-if = '$vuetify.breakpoint.smAndUp'>{{boundaries[s.rules.bounds_type]}}: </span><b>{{s.rules.name}}</b></v-list-item-title>
	            	</v-list-item-content>
	            	<v-list-item-action v-if = 'canCreate' style = 'min-width: auto !important;' class = 'mx-0 px-0'>
	            		<notification-delete class = 'px-1 mx-0' :data = 's' :projectId = 'project.project_id'></notification-delete>
	            	</v-list-item-action>
	            </v-list-item>
	            <v-list-item :class = '$vuetify.breakpoint.smAndUp? "":"pl-4"'>
	            	<v-list-item-content v-if = 's.rules.bounds_type == "relative"'>
	            		<v-list-item-title class = 'body-1'>
							<span style = 'min-width: 0 !important;'>Отслеживается отклонение на {{s.rules.target_value * 100}}%</span>
						</v-list-item-title>
	            		<v-list-item-subtitle class = 'caption'>
							<span>Группировка по столбцу <b>{{s.granularity}}</b></span>
						</v-list-item-subtitle>
	            	</v-list-item-content>
	            </v-list-item>
	        </v-list-group>
		</v-list>
		<dialog-fullscreen :visibility.sync = 'visibility' :indicator = 'indicator'>
			<template v-slot:title>Создание уведомления</template>
			<template v-slot:action>
				<v-btn 
					text 
					:disabled = '!notificationValid'
					:loading = 'indicator'
					color='green darken-2' 
					@click = 'createNotification'
				>
					Создать
				</v-btn>
			</template>
			<template v-slot:content>
				<v-form v-model = 'notificationValid' style = 'min-width: 320px; max-width: 420px;'>
					<v-select
						v-model = 'notification.period'
						:items = "dictToList(periods)"
						item-text = "value"
						item-value = "key"
						label = "Интервал проверки"
						hint = "Интервал проверки"
						persistent-hint
						single-line
						:rules = "[rules.required]"
						required
					></v-select>
					<v-select 
						v-model = 'formulaMode'
						:items = '[{"text": "Готовая", "value": 0, "disabled": false}, {"text": "Своя", "value": 1, "disabled": true}]'
						item-text = 'text' item-value = 'value'
						label = 'Ввод формулы'
						hint = 'Ввод формулы'
						persistent-hint
						single-line
					></v-select>
					<template v-if = 'formulaMode'>
						<v-text-field
							v-model = 'notification.rules.name'
							label = 'Название показателя'
							:rules = "[rules.required]"
						></v-text-field>
						<v-text-field
							v-model = 'notification.rules.formula'
							label = 'Формула расчета'
							:rules = "[rules.required]"
						></v-text-field>
					</template>
	            	<template v-else>
						<v-select 
							v-model = 'notification.rules' 
							:items = 'presets'
							item-text = 'name'
							return-object
							single-line
							:rules = "[rules.required]"
							label = 'Показатель'
						></v-select>
	            	</template>
	            	<v-select
						v-model = 'notification.rules.bounds_type'
						:items = "dictToList(boundaries)"
						item-text = "value"
						item-value = "key"
						label = "Тип проверки"
						hint = "Тип проверки"
						persistent-hint
						single-line
						:rules = "[rules.required]"
					></v-select>
	            	<v-text-field
						v-if = 'notification.rules.bounds_type != "interval"'
						v-model = 'notification.rules.target_value'
						label='Целевое значение'
						:hint = 'notification.rules.bounds_type == "relative"? "Процент изменения значения (от 0 до 100)": "Значение для сравнения"'
						:rules = "[rules.required, rules.numeric]"
						required
					></v-text-field>
		        	<template v-else>
						<v-text-field
							v-model = 'notification.rules.target_value_up'
							label='Верхняя граница'
							hint = 'Верхняя граница диапазона'
							persistent-hint
							:rules = "[rules.numeric]"
						></v-text-field>
						<v-text-field
							v-model = 'notification.rules.target_value_down'
							label='Нижняя граница'
							hint = 'Нижняя граница диапазона'
							persistent-hint
							:rules = "[rules.numeric]"
						></v-text-field>
					</template>
					<v-select 
						v-model = 'notification.granularity'
						:items = 'fields.dimensions'
						label = 'Столбец для группировки'
						persistent-hint
						single-line
						:rules = "[rules.required]"
					></v-select>
					<v-select 
						v-model = 'restrictionMode'
						:items = '[{"text": "Без фильтрации", "value": 0}, {"text": "Фильтровать", "value": 1}]'
						item-text = 'text' item-value = 'value'
						label = 'Режим фильтрации'
						hint = 'Режим фильтрации'
						persistent-hint
						single-line
					></v-select>
	            	<template v-if = 'restrictionMode'>
						<v-select
							v-model = 'notification.granularity_restriction.check_type'
							:items = "dictToList(restrictions)"
							item-text = "value"
							item-value = "key"
							label = "Правило"
							hint = "Правило"
							:rules = "[rules.required]"
							persistent-hint
							single-line
						></v-select>
						<v-text-field
							v-model = 'notification.granularity_restriction.value'
							label = "Значение"
							hint = "Значение"
							:rules = "[rules.required]"
							persistent-hint
							single-line
						></v-text-field>
	            	</template>
					<v-layout row align-center>
						<v-btn 
							:loading = 'indicatorTest'
							depressed
							width = '420px'
							color = 'light-blue lighten-4' 
							class = 'mx-3 my-2'
							:disabled = '!notificationValid'
							@click = 'testNotification()'
						><v-icon left>mdi-flash-circle</v-icon>Проверить</v-btn>
					</v-layout>
					<v-layout column align-center v-if = 'notificationResult && notificationResult.result'>
						<span class = 'subheading green--text text--darken-3'>Проверка успешна</span>
						<span v-if = '!notificationResult.positive_values.length'>Отклонения на момент проверки: <b>Не найдены</b></span>
						<v-list style = 'width: 100%;'>
							<v-list-item v-for = '(r,ri) in notificationResult.positive_values' :key = 'ri' @click = '' style = 'border-bottom: 1px solid black;'>
								<v-list-item-action class = 'caption mr-4'>
									{{notificationResult.granularity}}
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title class = 'body-1'>{{r.dimension}}</v-list-item-title>
									<v-list-item-subtitle class = 'body-1'>Текущее: {{Math.round(r.current_value * 100) / 100}}; Предыдущее: {{Math.round(r.previous_value * 100) / 100}}; Отклонение: {{Math.round(r.value * 100) / 100}}</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-layout>
	            	<v-layout column align-center v-if = 'notificationResult && notificationResult.result === false'>
	            		<span class = 'subheading red--text text--darken-3'>Ошибка проверки</span>
	            	</v-layout>
				</v-form>
			</template>
		</dialog-fullscreen>
	</v-layout>
</template>

<script>
	import DeleteNotification from '@/components/entities/notifications/DeleteDialog.vue'
	import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'

	export default {
		name: 'UserNotificationController',
		props: ['project', 'canCreate'],
		components: {
			'notification-delete': DeleteNotification,
			'dialog-fullscreen': DialogFullscreen
		},
		data() {
			return {
				fields: {},
				restrictions: {
					'equal': 'Равно',
					'like': 'Содержит'
				},
				boundaries: {
					'relative': 'Относительное изменение',
					'absolute': 'Абсолютное изменение',
					'interval': 'Попадание в диапазон'
				},
				periods: {
					'd': 'Ежедневно',
					'w': 'Еженедельно',
					'm': 'Ежемесячно'
				},
				aggregations: [
					{'formula': 'SUM', 'name': 'Сумма'},
					{'formula': 'AVG', 'name': 'Среднее'}
				],
				presets: [
					{'name': 'Клики', 'formula': 'SUM(clicks)'},
					{'name': 'Показы', 'formula': 'SUM(impressions)'},
					{'name': 'Расход (до АК и НДС)', 'formula': 'SUM(cost_novat)'},
					{'name': 'CPC', 'formula': 'SAFE_DIVIDE( SUM(cost_novat), SUM(clicks))'},
					{'name': 'CPM', 'formula': 'SAFE_DIVIDE(SUM(cost_novat), SUM(impressions)) * 1000'},
					{'name': 'CTR', 'formula': 'SAFE_DIVIDE(SUM(clicks), SUM(impressions))'}
				],
				formulaMode: 0,
				restrictionMode: 0,
				notification: {
					rules: {},
					granularity_restriction: {}
				},
				visibility: false,
				visibilityDelete: false,
				indicator: false,
				indicatorSecondary: false,
				indicatorDelete: false,
				indicatorTest: false,
				notificationValid: false,
				notificationResult: {},
				rules: {
					required: value => !!value || 'Обязательное поле.',
					numeric: value => /^[0-9.,]+$/.test(value) || 'Введите число.'
				}
			}
		},
		computed: {
			notifications() {
				let n = this.$store.getters.userNotifications
				n.filter( (n) => {n.project_id == this.project.project_id});
				return n
			}
		},
		methods: {
			dictToList(dict) {
				return Object.keys(dict).map( (k) => { return {'key': k, 'value': dict[k]}})
			},
			getAvailableFields() {
	    		this.indicatorSecondary = true;
	    		this.$http.patch(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/notifications', 
		          {
		          	'login': this.$store.getters.userLogin
		          }, {
		          	headers: this.$store.state.restrictedHeaders
		          }).then( (r) => {
		          let response = r.body;
		          this.indicatorSecondary = false;
		          if (response.result) {
		          	delete response.result;
		            this.fields = response
		          } else {
		            console.log(response)
		          }
		        })
	    	},
	    	getUserNotifications() {
	    		this.indicator = true;
	    		this.$http.get(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/notifications', {
		          emulateJSON: true,
		          params: {'login': this.$store.getters.userLogin},
		          headers: this.$store.state.restrictedHeaders
		        }).then( (r) => {
		          let response = r.body;
		          this.indicator = false;
		          if (response.result) {
		            this.notifications = response.data
		          } else {
		            console.log(response)
		          }
		        })
	    	},
	    	testNotification() {
	    		this.indicatorTest = true;
	    		let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8'
		        }
		        if (this.notification.rules.target_value && this.notification.rules.target_value >= 1) {
		        	this.notification.rules.target_value = this.notification.rules.target_value / 100;
		        }
		        this.$http.post(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/notifications/test', {
			        ...{'login': this.$store.getters.userLogin},...{'notification': this.notification}
			        },{
			            headers: {...this.$store.state.restrictedHeaders,...requestHeaders
			        }
			    }).then( (r) => {
			    	this.indicatorTest = false;
			    	let response = r.body;
			    	if (response.result) {
			    		this.notificationResult = response;
			    	}
			    });
	    	},
			createNotification() {
				this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8'
		        }
			    this.$http.post(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/notifications', {
			        ...{'login': this.$store.getters.userLogin},...this.notification
			        },{
			            headers: {...this.$store.state.restrictedHeaders,...requestHeaders
			        }
			    }).then( (r) => {
			        let response = r.body;
			        if (response.result) {
						this.indicator = false;
						this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'notification'
                            },
                            once: false
                        })
			            this.$store.dispatch('requestUserNotifications');
			            this.visibility = false;
			        } else {
			            console.log(response)
			        }
			    }, (r) => {
			    	this.indicator = false;
			    	let error = r.body;
	        		console.log(error)
			    });
			}
		}
	}
</script>